/**
 * @generated SignedSource<<7f67c3d93d565b81470d9332127f054e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteNodeOption_deleteVaultItems_Mutation$variables = {
  connections: ReadonlyArray<string>;
  vaultItemIds: ReadonlyArray<string>;
};
export type DeleteNodeOption_deleteVaultItems_Mutation$data = {
  readonly deleteVaultItems: {
    readonly vaultItemDeletedIds: ReadonlyArray<string>;
  } | null;
};
export type DeleteNodeOption_deleteVaultItems_Mutation = {
  response: DeleteNodeOption_deleteVaultItems_Mutation$data;
  variables: DeleteNodeOption_deleteVaultItems_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vaultItemIds"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "vaultItemIds",
        "variableName": "vaultItemIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vaultItemDeletedIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteNodeOption_deleteVaultItems_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "VaultsDeleteVaultItemsMutationPayload",
        "kind": "LinkedField",
        "name": "deleteVaultItems",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DeleteNodeOption_deleteVaultItems_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "VaultsDeleteVaultItemsMutationPayload",
        "kind": "LinkedField",
        "name": "deleteVaultItems",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "vaultItemDeletedIds",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9a5dbf322f943da9c044897f2888dad9",
    "id": null,
    "metadata": {},
    "name": "DeleteNodeOption_deleteVaultItems_Mutation",
    "operationKind": "mutation",
    "text": "mutation DeleteNodeOption_deleteVaultItems_Mutation(\n  $vaultItemIds: [ID!]!\n) {\n  deleteVaultItems(input: {vaultItemIds: $vaultItemIds}) {\n    vaultItemDeletedIds\n  }\n}\n"
  }
};
})();

(node as any).hash = "afc1f7b06938c52bcca207a6d751df63";

export default node;
